import { render, staticRenderFns } from "./vAccordion.vue?vue&type=template&id=3e752389&scoped=true"
import script from "./vAccordion.vue?vue&type=script&lang=ts"
export * from "./vAccordion.vue?vue&type=script&lang=ts"
import style0 from "./vAccordion.vue?vue&type=style&index=0&id=3e752389&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e752389",
  null
  
)

export default component.exports